module.exports = __webpack_public_path__ + "media/images/lang_pl-be6d067d7621511b21a9b1759a6e393f.jpg";